import React, { useState } from "react";
import moment from "moment";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import Field from "designV2/components/Field";
import Button from "designV2/components/Button";
import "./orderModals.css";

const DELIVERED = gql`
  mutation changeStatusToDeliveredByShopAdmin(
    $orderId: ID!
    $receiverName: String!
    $receiverPhoneNumber: String!
    $deliveryDate: Date!
  ) {
    changeStatusToDeliveredByShopAdmin(
      orderId: $orderId
      receiverName: $receiverName
      receiverPhoneNumber: $receiverPhoneNumber
      deliveryDate: $deliveryDate
    ) {
      _id
    }
  }
`;

const readableError = (error) => {
  if (!error) return "";
  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    return error.graphQLErrors[0].message;
  }
  return error.message || "Something went wrong, please try again.";
};

const DeliveryOrder = ({ orderId, close }) => {
  const [receiverName, setReceiverName] = useState("");
  const [receiverPhoneNumber, setReceiverPhoneNumber] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [error, setError] = useState("");

  const [changeStatusToDeliveredByShopAdmin, { loading }] = useMutation(DELIVERED);

  const onSubmit = () => {
    if (loading) return;
    const errors = {};
    if (!receiverName.trim()) errors.receiverName = "Receiver name is required.";
    if (!receiverPhoneNumber.trim()) {
      errors.receiverPhoneNumber = "Receiver phone number is required.";
    } else if (!/^\+?\d+$/.test(receiverPhoneNumber.trim())) {
      errors.receiverPhoneNumber = "Invalid phone number format.";
    }
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }
    setFieldErrors({});
    setError("");

    changeStatusToDeliveredByShopAdmin({
      variables: {
        orderId,
        receiverName: receiverName.trim(),
        receiverPhoneNumber: receiverPhoneNumber.trim(),
        deliveryDate: moment().toDate(),
      },
    })
      .then(() => close())
      .catch((err) => setError(readableError(err)));
  };

  return (
    <div className="orderModalBody">
      <Field label="Receiver name" required htmlFor="receiverName" error={fieldErrors.receiverName}>
        <input
          id="receiverName"
          type="text"
          className="dsInput"
          value={receiverName}
          onChange={(e) => setReceiverName(e.target.value)}
        />
      </Field>

      <Field
        label="Receiver phone number"
        required
        htmlFor="receiverPhoneNumber"
        error={fieldErrors.receiverPhoneNumber}
      >
        <input
          id="receiverPhoneNumber"
          type="text"
          className="dsInput"
          value={receiverPhoneNumber}
          onChange={(e) => setReceiverPhoneNumber(e.target.value)}
        />
      </Field>

      <Field label="Delivery time" htmlFor="deliveryTime" hint="Recorded as right now.">
        <input id="deliveryTime" type="text" className="dsInput" value={moment().format("MMM D, YYYY hh:mm A")} readOnly />
      </Field>

      {error && (
        <div className="dsFormMessage error" role="alert">
          {error}
        </div>
      )}

      <div className="orderModalActions">
        <Button onClick={close}>Cancel</Button>
        <Button variant="primary" onClick={onSubmit} loading={loading}>
          Submit
        </Button>
      </div>
    </div>
  );
};

export default DeliveryOrder;
